import { Action, createReducer, on } from '@ngrx/store';
import { isNil } from 'lodash';
import * as LicensesActions from './actions';
import { LicensesState, initialLicensesState } from './state';

const reducer = createReducer(
  initialLicensesState,
  on(LicensesActions.loadLicenseTypes, (state, action): LicensesState => {
    return {
      ...state,
      licenseTypesLoading: isNil(state.licenseTypes)
    };
  }),
  on(LicensesActions.setLicenseTypes, (state, action): LicensesState => {
    return {
      ...state,
      licenseTypes: action.licenseTypes,
      licenseTypesMap: new Map(action.licenseTypes.map((type) => [type.type, type.displayName])),
      licenseTypesLoading: false
    };
  }),
  on(LicensesActions.setPermissionFlags, (state, action): LicensesState => {
    return {
      ...state,
      permissionFlags: action.permissionFlags,
      permissionFlagsLoaded: true
    };
  }),
  on(LicensesActions.setBalance, (state, action): LicensesState => {
    return {
      ...state,
      balance: action.balance
    };
  }),
  on(LicensesActions.setLoading, (state, action): LicensesState => {
    return {
      ...state,
      actionsInLoading: state.actionsInLoading + (action.loading ? 1 : -1)
    };
  }),
  on(LicensesActions.setAssignedLicense, (state, action): LicensesState => {
    return {
      ...state,
      assignedLicense: state.assignedLicense
    };
  })
);

export function licensesReducer(state: LicensesState, action: Action) {
  return reducer(state, action);
}
